import { documentSignsService } from '@/services/documentsigns.service';
import { SignMethod } from '@/sign/models/sign-constants';
import { SignDocumentPrivateKeyStrategy } from './sign-document-private-key.strategy';
import { MixWithDepositSignLoginPswDocumentSigning } from '@/sign/mixins/deposit-sign.mixin';
import { MixWithDiiaDocumentSigning } from '@/sign/mixins/diia-sign.mixin';
import { MixWithCloudKeyFileSystemDocumentSigning } from '../mixins/cloud-key-sign.mixin';
import { FileHashingResult } from '@/models/document-sign.models';
import { MixWithDefaultAppConfirmationDocumentSigning, MixWithDefaultQrCodeDocumentSigning } from '@/sign/mixins/general-sign.mixin';

abstract class AuthorSignDocumentPrivateKeyStrategy
  extends SignDocumentPrivateKeyStrategy {
  protected filesForSign: string;

  constructor(prms: any) {
    super(prms);
    this.filesForSign = prms.filesForSign;
  }

  protected async getHashes(): Promise<Array<FileHashingResult>> {
    return documentSignsService.getHashesForSigningByAuthor(this.documentVersionCode, this.keyType, this.filesForSign);
  }
}

export class AuthorSignDocumentFileSystemStrategy
  extends AuthorSignDocumentPrivateKeyStrategy {
  protected signMethod?: SignMethod = SignMethod.FileSystem;
}

export class AuthorSignDocumentDeviceStrategy
  extends AuthorSignDocumentPrivateKeyStrategy {
  protected signMethod?: SignMethod = SignMethod.Device;
}

export class AuthorSignDocumentCloudStrategy
  extends AuthorSignDocumentPrivateKeyStrategy {
  protected signMethod?: SignMethod = SignMethod.Cloud;

  constructor(prms: any) {
    super(prms);

    this.mobileAppName = prms?.mobileAppName;
  }
}

export class AuthorSignDocumentDepositSignLoginPswStrategy
  extends MixWithDepositSignLoginPswDocumentSigning(AuthorSignDocumentCloudStrategy) {}

export class AuthorSignDocumentDiiaStrategy
  extends MixWithDiiaDocumentSigning(AuthorSignDocumentCloudStrategy) {}

export class AuthorSignDocumentCloudKeyFileSystemStrategy
  extends MixWithCloudKeyFileSystemDocumentSigning(AuthorSignDocumentCloudStrategy) {}

export class AuthorSignDocumentWithQrCloudProviderStrategy
  extends MixWithDefaultQrCodeDocumentSigning(AuthorSignDocumentCloudStrategy) {
}

export class AuthorSignDocumentWithIdCloudProviderStrategy
  extends MixWithDefaultAppConfirmationDocumentSigning(AuthorSignDocumentCloudStrategy) {
}
